/*
 * @Date: 2022-09-23 18:55:01
 * @LastEditors: shikexin shikexin0116@163.com
 * @LastEditTime: 2022-09-26 10:52:36
 * @description: description
 */
import Vue from 'vue'
import Router from 'vue-router'

import VideosList from '@/components/VideoList.vue'
import Service from '@/view/training'
import Conf from '@/view/conf'
import SEO from '@/view/seo'
import Recruit from '@/view//recruit'
import Confs from '@/view/confs'

import Home from '@/view/home/Index.vue'
import News from '@/view/news/Index.vue'
import Number from '@/view/number.research/Index.vue'
import Aboutus from '@/view/aboutus/Index.vue'
import Partner from '@/view/partner'

Vue.use(Router)

const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    return savedPosition
  }
}

const router = new Router({
  mode: 'history',
  scrollBehavior,
  routes: [
    { name: 'home', path: '/', component: Home },
    { name: 'news', path: '/news', component: News, meta: { title: '新闻动态' } },
    { name: 'Number', path: '/number', component: Number, meta: { title: '双数研究院' } },
    { name: 'aboutus', path: '/aboutus', component: Aboutus, meta: { title: '关于我们' } },
    { name: 'partner', path: '/partner', component: Partner },
    { name: 'conf', path: '/conference', component: Conf },
    { name: 'video', path: '/video/:id', component: VideosList },
    { name: 'service', path: '/service', component: Service },
    { name: 'confs', path: '/conference-schedule', component: Confs },
    { name: 'seo', path: '/seo', component: SEO },
    { name: 'recruit', path: '/recruit', component: Recruit },
    { path: '*', redirect: '/' }
  ]
})

router.afterEach((to, from) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
})

export default router
